import styled from '@emotion/styled';
import { FONT, COLORS } from '../../../../styles/emotion';

export const Tooltip = styled.span`
  visibility: hidden;
  width: 120px;
  text-align: center;
  padding: 5px 10px !important;
  background-color: ${COLORS.BLACK};
  border-radius: 3px;
  color: ${COLORS.WHITE};
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  line-height: 15px;

  position: absolute;
  z-index: 1;

  width: 120px;
  bottom: calc(100% + 9px);
  left: 50%;
  margin-left: -60px !important; /* Use half of the width (120/2 = 60), to center the tooltip */

  &::after {
    content: ' ';
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
`;

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;

  &:hover {
    & ${Tooltip} {
      visibility: visible;
    }
  }
`;
